import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { openAlertsPercentage, openAlertsPercentageDelta = 0 } = data || {};

    return createKpiTileItem(
      'Open Alerts',
      formatPercentageValue(openAlertsPercentage),
      Number(openAlertsPercentageDelta) !== 0
        ? {
            isPositiveValue: openAlertsPercentageDelta >= 0,
            text: formatPercentageValue(Math.abs(openAlertsPercentageDelta)),
            sideLabel: '',
          }
        : null
    );
  },
};
